import { enumParser } from '#validation/common/parsers';
import { WorkspaceMfaRequirement } from '../constants';
export const workspaceMfaRequirementParser = enumParser(WorkspaceMfaRequirement);
